export const transformTextToId = (text?: string) =>
  text ? text.replace(/\s/g, '-').replace(/,/g, '').toString().toLocaleLowerCase() : '';
